import React from "react";
import { Tag, Typography } from "antd";

const { Text } = Typography;

// Tallas / género / colores de un producto de Ropa, usado en la tarjeta del catálogo.
export default function ProductBadges({ product }) {
  return (
    <div style={{ marginTop: 8, fontSize: 12 }}>
      <div>
        <Text strong style={{ fontSize: 12 }}>Tallas: </Text>
        {product.sizes?.length > 0 ? (
          product.sizes.map((size) => (
            <Tag key={size} style={{ marginBottom: 4 }}>{size}</Tag>
          ))
        ) : (
          <Text type="secondary" style={{ fontSize: 12 }}>No especificadas</Text>
        )}
      </div>

      <div style={{ marginTop: 4 }}>
        <Text strong style={{ fontSize: 12 }}>Para: </Text>
        <Tag color="purple">{product.gender || "No especificado"}</Tag>
      </div>

      <div style={{ marginTop: 4 }}>
        <Text strong style={{ fontSize: 12 }}>Colores: </Text>
        {product.colors?.length > 0 ? (
          product.colors.map((color) => (
            <Tag key={color} color="blue" style={{ marginBottom: 4 }}>{color}</Tag>
          ))
        ) : (
          <Text type="secondary" style={{ fontSize: 12 }}>No especificados</Text>
        )}
      </div>
    </div>
  );
}
